import { mixpanel } from '@fiverr-private/obs';
import { type MixpanelEventName } from './mixpanel.types';
import { MIXPANEL_EVENT_DATA_DEFAULT } from './mixpanel.constants';

const createMixpanelReporter = () => {
    const send = (name: MixpanelEventName, data: Record<string, string> = {}) => {
        mixpanel.track(name, { ...data, ...MIXPANEL_EVENT_DATA_DEFAULT });
    };

    return {
        send,
    };
};

export const globalMixpanelReporter = createMixpanelReporter();
